import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ClipboardTextIcon } from '@repo/icons';
import Button from '../Button/Button';
import { getLabels } from '../labels';
import CodeInput from './CodeInput';
import { useCodeInput } from './hooks/useCodeInput';
const noop = () => { };
export default function CodeInputGroup({ length, onComplete = noop, testId, variant = 'separated', showPasteButton = true, pasteButtonLabel, label, className, disabled = false, required = false, resetOnComplete = false, autoFocus = false, compact = false, onPasteError, value, onChange, }) {
    const { pasteButtonLabel: defaultPasteButtonLabel } = getLabels().codeInput;
    const { inputsRef, getValueAt, handleKeyDown, handleFocus, handlePaste, handlePasteFromClipboard } = useCodeInput({
        length,
        onComplete,
        resetOnComplete,
        value,
        onChange,
    });
    const resolvedPasteButtonLabel = pasteButtonLabel ?? defaultPasteButtonLabel;
    const handlePasteClick = async () => {
        try {
            await handlePasteFromClipboard();
        }
        catch {
            onPasteError?.();
        }
    };
    return (_jsxs("div", { className: classNames('flex w-full min-w-0 flex-col items-center gap-4.5', className), children: [label && (_jsxs("div", { className: "text-heading w-full text-start text-sm leading-6", children: [label, required && _jsx("span", { className: "text-fg-danger ml-1", children: "*" })] })), _jsx("div", { className: classNames('isolate grid w-full min-w-0', {
                    'gap-2': variant === 'separated' && !compact,
                    'gap-1': variant === 'separated' && compact,
                    'gap-0': variant === 'connected',
                    'border-stroke-base-medium rounded-lg border': variant === 'connected' && compact,
                }), style: { gridTemplateColumns: `repeat(${length}, minmax(0, 1fr))` }, children: Array.from({ length }, (_, index) => (_jsx(CodeInput, { index: index, ref: (handle) => {
                        inputsRef.current[index] = handle;
                    }, value: getValueAt(index), testId: testId.append(index.toString()), onKeyDown: (event) => handleKeyDown(index, event), onFocus: () => handleFocus(index), onPaste: (event) => handlePaste(index, event), variant: variant, totalInputs: length, disabled: disabled, compact: compact, autoFocus: autoFocus && index === 0 }, index))) }), showPasteButton && resolvedPasteButtonLabel && (_jsx(Button, { color: "ghost", leftIcon: ClipboardTextIcon, testId: testId.append('pasteCode'), className: "text-brand-strong! border-0!", onClick: handlePasteClick, tabIndex: disabled ? -1 : 0, disabled: disabled, children: resolvedPasteButtonLabel }))] }));
}
